import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseHttpService } from 'src/app/service/base-http.service';

@Component({
  selector: 'app-sys-user-list',
  templateUrl: './sys-user-list.component.html',
  styleUrls: ['./sys-user-list.component.css']
})
export class SysUserListComponent implements OnInit {
	error=null
	loading = false
	sysUserList=null
	sysUserPagination={
		currentPage:1,
		pageSize:10,
		pageCount:0,
		rowCount:0,
		pageList:null
	}
	searchForm: FormGroup=this.formBuilder.group({
		fullnameLike: ['' ,[ Validators.maxLength(200)] ],
		usernameLike: ['' ,[ Validators.maxLength(200)] ],
		emailLike: ['' ,[ Validators.maxLength(200)] ],
		phoneNumberLike: ['' ,[ Validators.maxLength(200)] ],
		status: [null ]
	});
	userStatusOptionList=[
		{ value : null, label : "Tất cả" },
		{ value : 0, label : "Ngừng sử dụng" },
		{ value : 1, label : "Sử dụng" }
	]
	userStatusOptionMap={}
	constructor(private formBuilder: FormBuilder,
	private httpService:BaseHttpService,
	private route: ActivatedRoute,
	private router: Router ) { }
	ngOnInit(): void {
		for(var userStatusOption of this.userStatusOptionList){
			this.userStatusOptionMap[userStatusOption.value]=userStatusOption.label;
		}
		this.searchUser();
	}

	sysUserPageChange(page){
		if(this.loading){
			return;
		}
		this.error=null;
		var searchFormData=this.searchForm.getRawValue()
		var findRequest:any = {}
		var fullnameLike = searchFormData["fullnameLike"];
		if(fullnameLike){
			findRequest.fullnameLike= `%${fullnameLike}%`;
		}
		var usernameLike = searchFormData["usernameLike"];
		if(usernameLike){
			findRequest.usernameLike= `%${usernameLike}%`;
		}
		var emailLike = searchFormData["emailLike"];
		if(emailLike){
			findRequest.emailLike= `%${emailLike}%`;
		}
		var phoneNumberLike = searchFormData["phoneNumberLike"];
		if(phoneNumberLike){
			findRequest.phoneNumberLike= `%${phoneNumberLike}%`;
		}
		var status = searchFormData["status"];
		if(status !== null){
			findRequest.status= status;
		}
		if(page<1){
			page=1
		}
		findRequest.queryOffset=(page-1)*this.sysUserPagination.pageSize;
		findRequest.queryLimit=this.sysUserPagination.pageSize;
		this.loading=true;
		this.httpService.post<any>(`/api/admin/sys/user/search`,findRequest).subscribe(findOtpUserResponse=>{
			this.loading=false;
			var rowCount = findOtpUserResponse.rowCount;
			var pageCount = Math.ceil(rowCount/this.sysUserPagination.pageSize);
			var pageList=[]
			for(var i=page-2;i<=page+2;i++){
				if(i>=1&&i<=pageCount){
					pageList.push(i);
				}
			}
			this.sysUserPagination.currentPage=page;
			this.sysUserPagination.rowCount=rowCount;
			this.sysUserPagination.pageCount=pageCount;
			this.sysUserPagination.pageList=pageList;
			this.sysUserList= findOtpUserResponse.resultList;
		},errorResponse=>{
			this.loading=false;
			if(errorResponse.status==403){
			  this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
			  return;
			}
      if(errorResponse.status>0){
        if(errorResponse.error?.errorCode){
          this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
          return;
        }
        this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
        return;
      }
      this.error="Lỗi kết nối! Vui lòng thử lại sau";
		});
	}
	searchUser(){
		this.sysUserPageChange(1);
	}
	viewUser(sysUser){
		this.router.navigate(['view',sysUser.id],{ relativeTo: this.route })
	}
	insertUser(){
		this.router.navigate(['create'],{ relativeTo: this.route })
	}
	passwordUser(sysUser){
		this.router.navigate(['password',sysUser.id],{ relativeTo: this.route })
	}
	editUser(sysUser){
		this.router.navigate(['edit',sysUser.id],{ relativeTo: this.route })
	}
}


